import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './routes';
import './index.css';
import { initSentry } from './lib/sentry';
import { AlgorandWalletProvider } from './components/wallet/AlgorandWalletProvider';

// Initialize Sentry error monitoring
if (import.meta.env.VITE_SENTRY_DSN) {
  initSentry();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AlgorandWalletProvider>
      <Routes />
    </AlgorandWalletProvider>
  </StrictMode>
);